export default __webpack_public_path__ + "static/media/0.eef377f5.png";